import styles from './BookedState.module.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OfferedMaterial } from '../../api/bookingApi.types';

interface BookedMaterialsProps {
  materials: OfferedMaterial[];
}

/** The preparation links the hiring team shared, opened without passing the page's token on as a referrer. */
const BookedMaterials: FC<BookedMaterialsProps> = ({ materials }) => {
  const { t } = useTranslation();

  if (materials.length === 0) {
    return null;
  }

  return (
    <section className={styles.panel} aria-labelledby="public-scheduling-prepare">
      <h2 id="public-scheduling-prepare" className={styles.panelTitle}>
        {t('publicScheduling.prepareTitle')}
      </h2>
      <ul className={styles.list}>
        {materials.map(material => (
          <li key={material.url}>
            <a
              className={styles.link}
              href={material.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {material.label}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default BookedMaterials;
